export const API_STATUS_ACTION_TYPES = {
  BEGIN_API_CALL: 'BEGIN_API_CALL',
  API_CALL_ERROR: 'API_CALL_ERROR'
};
